"use strict";
(function(window) {
    window.CommonComponent = function() {
        this.initComponent();
    };

    $.extend(window.CommonComponent.prototype, {
        initComponent: function () {
            var $GalleryShowAllBtn = $('.js-gallery-show-all');

            if ($GalleryShowAllBtn.length) {
                $GalleryShowAllBtn.click(function (e) {
                    e.preventDefault();

                    $(this).parent().siblings('.js-gallery-modal').modal();
                });
            }
        }
    });
})(window);

$(document).ready(function() {
    var commonComponent = new CommonComponent();
});
